<template>
	<div class="fcast-map" @click="changePoi($event)">
		<div ref="map" :id="`lnc-map${bSmallWidth? 'SW' : ''}`">
			<div id="check">
				<input @click="switchUnit" type="checkbox" :checked="bIsMetric"> Vent en km/h
			</div>
		</div>
		
		<div :class="`period-selector${bSmallWidth? 'SW' : ''} fzs tac ttu fwb`">
			<div class="dib box mrs" :class="{ 'active' : period == null || period == 0 }" v-on:click="changePeriod(0)">nuit</div>
			<div class="dib box mrs" :class="{ 'active' : period == 1 }" v-on:click="changePeriod(1)">matin</div>
			<div class="dib box mrs" :class="{ 'active' : period == 2 }" v-on:click="changePeriod(2)">{{bSmallWidth? 'AM' : 'après-midi'}}</div>
			<div class="dib box mrs" :class="{ 'active' : period == 3 }" v-on:click="changePeriod(3)">soir</div>
		</div>

	</div>
</template>

<script>
import L from 'leaflet'
import 'leaflet/dist/leaflet.css'
import axios from 'axios'

import '../../node_modules/@fortawesome/fontawesome-free/css/all.css'
import '../../node_modules/@fortawesome/fontawesome-free/js/all.js'
import uparrow from '@/assets/uparrow.png'

export default {
	name: 'ForecastMap',
	props: ['dt', 'period'],

	data() {
		return {
			map: null,
			geojson: null,
			days: null,
			markers: [],

			fcasts: null,
			cities: null,

			bIsMetric: false,

			bSmallWidth: false
		}
	},

	watch: {
		dt() {
			this.loadFcast(this.dt, this.period, (this.bIsMetric)? 60 : 40)
		},
		period() {
			this.loadFcast(this.dt, this.period, (this.bIsMetric)? 60 : 40)
		}
	},

	mounted() {
		var self = this

		self.bSmallWidth = (window.innerWidth <= 850)? true : false;

    	window.addEventListener('resize', () => {
    		let oldSW = self.bSmallWidth;
    		
    		if (window.innerWidth <= 850) {
    			self.bSmallWidth = true;
    			self.map.setZoom(6.25);
    		}
    		else {
    			self.bSmallWidth = false;
    			self.map.setZoom(7.75);
    		}

    		if (oldSW === !self.bSmallWidth) {
    			self.loadFcast(self.dt, self.period, (self.bIsMetric)? 60 : 40);
    		}

    	});

		var geojsonStyle = {
		  'color': 'white',
		  'fill': true,
		  'fillColor': '#274875',
		  'fillOpacity': 1,
		  'weight': 1,
		  'opacity': 1,
		}

		var promGeojson = axios.get('/data/nv-caledonie.json').then(function(resp) {
			self.map = L.map(self.$refs.map.id, {
				center: [-21.4, 166],
				zoom: (self.bSmallWidth? 6.25 : 7.75),
				zoomSnap: 0.25,
				zoomControl: false,
				scrollWheelZoom: false,
				attributionControl: false,
				doubleClickZoom: false,
				dragging: false
			})
			self.geojson = L.geoJSON(resp.data, { style: geojsonStyle }).addTo(self.map);
			//self.map.fitBounds(self.geojson.getBounds());

			self.loadFcast(self.dt, self.period, (self.bIsMetric)? 60 : 40)
		});
	},

	methods: {
		math_kmhToKnots(v) {
			return v / 1.852;
		},
		math_knotsToKmh(v) {
			return v * 1.852;
		},
		getInCurrentUnit(v) {
			if(v == "-") return v
			return this.bIsMetric? Math.round(v) +' km/h' : Math.round(this.math_kmhToKnots(v)) +' kt';
		},
		switchUnit() {
			this.bIsMetric = !this.bIsMetric;

			this.loadFcast(this.dt, this.period, (this.bIsMetric)? 60 : 40);
		},

		changePeriod (per) {
			this.$emit('period-changed', per)
		},
		loadFcast (dt, per, windTextContainerWidth) {
			let self = this
			let method = '/forecast/map/' + this.$moment(dt).format('YYYY-MM-DD')  + '/' + per
			axios.get(process.env.VUE_APP_API + method).then(function(resp) {
				let fcasts = resp.data
				let points = self.$parent.$data.pointsIdx

				/* remove current markers */
				for(let i = 0; i < self.markers.length; i++) {
					self.markers[i].remove()
				}
				self.markers = []

				const swBannedGeonames = [
					'2137748',
					'2137690',
					'2137644'
				];

				for(let fcast of fcasts.cities) {

					if (!self.bSmallWidth || swBannedGeonames.findIndex(e => e == fcast.geoname) == -1) {
						let iconClass = per == 0 || per == 3 ? 'ico-ts-' + fcast.ts + '-moon' : 'ico-ts-' + fcast.ts

						let point = points[fcast.geoname]

						let html = `<div>
										<div class="tmin">
											${fcast.tmin}°C
										</div>
										<div class="tmax">
											${fcast.tmax}°C
										</div>
										<i data-geoname="${fcast.geoname}" title="${point.name}" class="ts${self.bSmallWidth? 'SW' : ''} ${iconClass}">
										</i>
									</div>`;

						let marker = L.marker([point.latitude, point.longitude], {
							icon: L.divIcon({
								iconSize: [0, 0],
								className: `map-marker${self.bSmallWidth? 'SW' : ''}`,
								html: html
							})
						})
						marker.addTo(self.map)
						self.markers.push(marker)

					}
				}

				let i = 0;
				for(let fcast of fcasts.others) {
					console.log(fcast);

					let html = `<div class="wind">
									<div class="text fwb">
										${self.getInCurrentUnit(fcast.w)}<br/>
									</div>
									<div class="icon${self.bSmallWidth? 'SW' : ''}">
										<i style="color: #f5d022; font-size: 3em; transform: translateY(-20%) translateX(-10px);">
										<img class="ico-wind-${fcast.w_dir}" style="height: ${self.bSmallWidth? '0.5em' : '1em'};" src="${uparrow}" />
										</i>
									</div>
								</div>`;

					let marker = L.marker([fcast.coords.latitude, fcast.coords.longitude], {
						icon: L.divIcon({
							iconSize: [windTextContainerWidth, 20],
							className: `map-marker${self.bSmallWidth? 'SW' : ''} nocursor`,
							html: html
						})
					})
					marker.addTo(self.map)
					self.markers.push(marker)
					i++;
				}
			})
		},
		changePoi(event) {
			let geoname = event.target.dataset.geoname
			if(geoname == null) return
			event.target.classList.add('active');
			this.$emit('poi-changed', geoname)
		}
	}
}
</script>

<style lang="scss">
@import "@/assets/saas/charter.scss";
@import "@/assets/fonts/main.scss";

.fcast-map {

	.specialcursor {
		transform: translateX(-60%) translateY(80%);
	}
	.specialcursor .icon {
		transform: translateX(70%) translateY(-80%);
	}

	#check {
		color: white;
		font-size: 12px;
		bottom: 0;
		left: 0;
    	position: absolute;
	}

	#lnc-map {
		height: 610px;
		width: 100%;
	}
	#lnc-mapSW {
		width: 100%;
		height: 260px;	
	}

	.map-marker {

		font-family: $open-sans-bold;
		font-weight: normal;
		font-size: 11px;

	}
	.map-markerSW {

		font-family: $open-sans-bold;
		font-weight: normal;
		font-size: 9px;

	}

	.map-marker .tmin, .map-marker .tmax {
		transform: translateX(11px) translateY(9px);
		line-height: 1em;
		background-color: white;
		width: 36px;
		text-align: center;
	}
	.map-markerSW .tmin, .map-markerSW .tmax {
		transform: translateX(11px) translateY(9px);
		line-height: 1em;
		background-color: white;
		width: 30px;
		text-align: center;
	}

	.map-marker .tmin, .map-markerSW .tmin {
		color: black;
		margin: 0;
		padding: 1px;
	}

	.map-marker .tmax, .map-markerSW .tmax {
		color: $pink-lnc;
		margin: 0;
		padding: 1px;
	}

	.map-marker i.ts {
		font-size: 6em; /* icon size */
		transform: translateX(-40%) translateY(-100%);
	}
	.map-markerSW i.tsSW {
		font-size: 3em; /* icon size */
		transform: translateX(-40%) translateY(-100%);
	}

	.map-marker .wind, .map-markerSW .wind {
		transform: translateY(38%) translateX(40%);
	}

	.map-marker .wind i, .map-markerSW .wind i, .specialcursor i {
		font-size: 2em;
		color: $yellow-lnc;
		display: block;
	}

	.map-marker .wind .icon {
		transform: translateY(-40%) translateX(-50%);
	}
	.map-markerSW .wind .iconSW {
		transform: translateY(-40%) translateX(-5%);
	}

	.map-marker .wind .text, .specialcursor .text {
		transform: translateY(10px) translateX(8px);
		color: white;
		background-color: $blue3-lnc;
		text-align: center;
		border: 1px solid $yellow-lnc;
		font-weight: normal;
	}
	.map-markerSW .wind .text, .specialcursor .text {
		transform: translateY(10px) translateX(8px);
		color: white;
		background-color: $blue3-lnc;
		text-align: center;
		border: 1px solid $yellow-lnc;
		font-weight: normal;
	}

	.map-marker > div i:after, .map-markerSW > div i:after {
		font-size: 8pt !important;
		font-style: normal;
		font-weight: bold;

		content: attr(title);
		display: block;
		position: absolute;
		top: 2.5em;
		left: -0.5em;
		white-space: nowrap;
		color: #222;
		
		background-color: #FFF;
		padding: 0 0.5em;
		border-radius: 2em;
		transition: .3s;
		transform: translateX(-50%) translateY(-100%);
		visibility: hidden;
		opacity: 0;
	}

	.map-marker > div i:hover:after, .map-markerSW > div i:hover:after {
		visibility: visible;
		opacity: 1;
		background-color: white;
	}

	.map-city {
		font-size: 1em;
		color: black;

	}

	.leaflet-interactive.nocursor {
		cursor: default !important;
	}

	.leaflet-container {
		background-color: $blue1-lnc;
	}

	.period-selector div
	{
		font-family: $yan-kaff-bold;
		font-size: 20px;
		font-weight: normal;
		background-color: $blue1-lnc;
		border-bottom: 10px solid $blue1-lnc;
		margin-top: 10px;
		width: 150px;
		color: white;
		cursor: pointer;
	}
	.period-selectorSW div
	{
		font-family: $yan-kaff-bold;
		font-size: 15px;
		font-weight: normal;
		background-color: $blue1-lnc;
		border-bottom: 10px solid $blue1-lnc;
		margin-top: 10px;
		width: 40px;
		color: white;
		cursor: pointer;
		padding: 0.3em;
	}

	.period-selector div.active, .period-selector div:hover {
		color: $pink-lnc;
		border-bottom: 10px solid $pink-lnc;
		background-color: white;
	}
	.period-selectorSW div.active, .period-selector div:hover {
		color: $pink-lnc;
		border-bottom: 10px solid $pink-lnc;
		background-color: white;
	}
}

</style>
